import {TreeItem} from '@pb/kit-component-tree-v2';

export const getOptionLabelFromTree = (tree: TreeItem, value: string, resultLabel: string): string => {
    const updatedLabel = resultLabel ? `${resultLabel}/${tree.caption}` : tree.caption;

    if (tree.id === value && !tree.children && updatedLabel) {
        return updatedLabel;
    }

    if (tree.children && updatedLabel) {
        for (const child of tree.children) {
            const label = getOptionLabelFromTree(child, value, updatedLabel);
            if (label) {
                return label;
            }
        }
    }

    return '';
};
